import { ApiCrudObjectControllerBindings, CalcRepairInfoController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the repair info for the current calculation.
 * @example
 * ```html
 * <salaxy-calc-repair-info model="$ctrl"></salaxy-calc-repair-info>
 * ```
 */
export class CalcRepairInfo extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = (new class extends ApiCrudObjectControllerBindings {
    }());


  /** Uses the CalcRepairInfoController */
  public controller = CalcRepairInfoController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/calc/CalcRepairInfo.html";

}
